import React from 'react';
import icons from './../../icons.svg';
/* *
 * @param {Array of objects} options [{text:'Custom':value:'value'}, {text:'Default':value:'default'}]
 * @param {string} selectedOption
 * @param {function} onClick a call back when toggle is clicked
 * @returns
 */
export const Toggle = ({ options, selectedOption, onClick }) => {
  return (
    <div className="cp-toggle">
      <span
        className={
          selectedOption === options[0].value ? 'cp-toggle--active' : ''
        }
        onClick={() => onClick(options[0].value)}
      >
        {options[0].text || 'one'}
      </span>
      <span
        className={
          selectedOption === options[1].value ? 'cp-toggle--active' : ''
        }
        onClick={() => onClick(options[1].value)}
      >
        {options[1].text || 'two'}
      </span>
    </div>
  );
};

/**
 * a banner for short message
 * @param {*} message,
 * @param {*} className
 * @returns
 */
export const InfoBanner = ({ message, className }) => {
  return (
    <div className={`cp-info-banner ${className ? className : ''}`}>
      {message}
    </div>
  );
};

/**
 *
 * @param {string } type save | add | close | cancel | update | delete
 * @param {string} text text to disply on the button(optional)
 * @param {string} className custom css class name(optional)
 * @param {Function} onClick callback function when button is clicked
 * @returns
 */
export const Button = ({ type, text, className, onClick, mr, ml, mt, mb }) => {
  const buttonIcon = {
    save: { icon: 'icon-save', style: 'cp-button--save' },
    add: { icon: 'icon-plus-circle', style: 'cp-button--add' },
    close: { icon: 'icon-close-outline', style: 'cp-button--close' },
    cancel: { icon: 'icon-close-outline', style: 'cp-button--close' },
    update: { icon: 'icon-update', style: 'cp-button--update' },
    delete: { icon: 'icon-trash-2', style: 'cp-button--delete' },
    export: { icon: 'icon-export', style: 'cp-button--export' },
  };

  const style = `cp-button ${buttonIcon[type].style}${
    mr ? ' cp-button-mr' : ''
  }${ml ? ' cp-button-ml' : ''}${mt ? ' cp-button-mt' : ''}${
    mb ? ' cp-button-mb' : ''
  } ${className ? { className } : ''}`;

  return (
    <button className={style} onClick={() => onClick()}>
      <svg>
        <use xlinkHref={`${icons}#${buttonIcon[type].icon}`}></use>
      </svg>
      <span>{text ? text : type}</span>
    </button>
  );
};

export const supportedLanguages = [
  {
    val: 'bg',
    label: 'Bulgarian',
  },
  {
    val: 'cs',
    label: 'Czech',
  },
  {
    val: 'da',
    label: 'Danish',
  },
  {
    val: 'de',
    label: 'German',
  },
  {
    val: 'de-CH',
    label: 'Swiss German',
  },
  {
    val: 'en',
    label: 'English',
  },
  {
    val: 'es',
    label: 'Spanish',
  },
  {
    val: 'et',
    label: 'Estonian',
  },
  {
    val: 'fi',
    label: 'Finnish',
  },
  {
    val: 'fr',
    label: 'French',
  },
  {
    val: 'hu',
    label: 'Hungarian',
  },
  {
    val: 'it',
    label: 'Italian',
  },
  {
    val: 'lv',
    label: 'Latvian',
  },
  {
    val: 'no',
    label: 'Norwegian',
  },
  {
    val: 'pt',
    label: 'Portuguese',
  },
  {
    val: 'ro',
    label: 'Romanian',
  },
  {
    val: 'sv',
    label: 'Swedish',
  },
  {
    val: 'tr',
    label: 'Turkish',
  },
];
